import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";
import TermsAndConditions from "terms_and_conditions/TermsAndConditions";

export default function TermsAndConditionsModal(props) {
  console.log(props);

  const [isModalVisible, setIsModalVisible] = useState(props.show || false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const hideModal = () => setIsModalVisible(false);

  const acceptTerms = async () => {
    try {
      const response = await fetch(`/datapulse/users/accept-terms-and-conditions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ accepted: acceptedTerms }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showAlert("Terms and Conditions accepted successfully.", "success");
        } else {
          if (data.error) {
            showAlert(data.error, "danger");
          } else {
            showAlert("An error occurred while joining the organization. Please try again.", "danger");
          }
        }

      } else {
        showAlert("An error occurred while joining the organization. Please try again.", "danger");
      }
    } catch (error) {
      console.log(error)
      showAlert("An error occurred while joining the organization. Please try again.", "danger");
    } finally {
      hideModal()
    }
  } 

  return (
    <>
      <Modal show={isModalVisible} onHide={() => {}} className="terms-and-conditions-modal">
        <Modal.Header>
          <Modal.Title>
            <h4>Terms & Conditions</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <p className="mb-2"><b className="red">You must accept our updated Terms and Conditions to continue using DataPulse.</b></p>
            <div className="datapulse-terms-and-conditions">
              <TermsAndConditions />
            </div>
          </div>

          <div className="terms-and-conditions-footer" style={{justifyContent: "flex-end"}}>
            <div className="accept-box">
              <div className="lite-checkbox-container">
                <label htmlFor="accept-terms-checkbox">I accept the Terms and Conditions</label>
                <input type="checkbox" id="accept-terms-checkbox" name="accept-terms-checkbox" className="lite-checkbox" onChange={() => setAcceptedTerms(!acceptedTerms)} checked={acceptedTerms} />
              </div>
              <button type="button" className={`button b-type-primary b-size-normal b-color-green ${!acceptedTerms && "disabled"}`} onClick={acceptTerms} disabled={!acceptedTerms}>
                Next
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
